<template>
  <v-container fluid>
    <page-header>
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/teachers">Teachers</v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :to="backRoute">
          {{ teacher ? `${teacher.firstName} ${teacher.lastName}` : "N/A" }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true"> New Rate </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>
    <v-card width="100%" class="mx-auto">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" lg="6">
              <v-text-field prepend-icon="mdi-label" label="Label" v-model="rate.name" :rules="[rules.required]" />
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field prepend-icon="mdi-currency-usd" type="number" min="0.01" step="0.01" label="Hourly Rate" v-model="rate.hourlyRate" :rules="[rules.required]" />
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field clearable prepend-icon="mdi-calendar" label="Start Date" v-model="rate.startDate" type="date" />
            </v-col>
            <v-col cols="12" lg="6">
              <v-text-field clearable prepend-icon="mdi-calendar" label="End Date" v-model="rate.endDate" type="date" />
            </v-col>
            <v-col cols="12">
              <v-textarea prepend-icon="mdi-note" rows="1" :auto-grow="true" label="Remark" v-model="rate.remark" />
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :to="backRoute" class="mx-5">Cancel</v-btn>
          <v-btn @click="saveRate" color="primary" class="mx-5">{{
            rate.id ? "Update" : "Save"
          }}</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { rules } from "@/store/util/rules.js";

const PageHeader = () => import("@/components/common/PageHeader.vue");

export default {
  data() {
    return {
      rate: {
        id: null,
        startDate: new moment().format("YYYY-MM-DD"),
        endDate: null,
        hourlyRate: 0,
        remark: null,
        name: 'Primary Rate',
        teacherId: null
      },
      startDateMenu: false,
      endDateMenu: false,
      teacher: {},
      backRoute: {
        name: "Teacher",
        params: { id: this.$route.params.teacherId, tab: "tab-info" },
      },
      rules,
    };
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  mounted() {
    this.initRate();
    this.initTeacher();
  },
  components: {
    PageHeader,
  },
  methods: {
    ...mapActions([
      "hideDialog",
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),
    initRate() {
      const rateId = this.$route.params.id;
      if(!rateId){
        return;
      }

      const params = {
        id: rateId,
      };
      return this.$axios.get("/teacher/get-rate", { params }).then((resp) => {
        this.rate = resp.data.data;
      })
      .catch( () => {
        this.addErrorMessage("Error retrieving teacher's rate");
      })
    },
    initTeacher() {
      const teacherId = this.$route.params.teacherId
        ? this.$route.params.teacherId
        : null;
      if (teacherId) {
        this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then((resp) => {
            this.teacher = resp.data.data;
          });
      }
    },
    saveRate() {
      if (!this.$refs.form.validate()) {
        this.addMessage("Please check your input");
        return;
      }

      this.rate.teacherId = this.teacher.id;

      this.$axios
        .post("/teacher/rate/update", this.rate)
        .then((resp) => {
          this.rate = resp.data.data;
          this.addSuccessMessage("Teacher rate updated");
          this.$router.push(this.backRoute);
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    
  },
};
</script>

<style>
</style>